/**
 * Campaign status
 */
export enum CampaignStatus {
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
}

/**
 * Campaign type
 */
export enum CampaignType {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  EMAIL_CAMPAIGN = 'EMAIL_CAMPAIGN',
  MIXED = 'MIXED',
}
